import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { coursegroupsApi } from "./coursegroupsApi";

export const useCourseGroup = (courseGroupId: string | undefined) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_GROUP_BY_ID(Number(courseGroupId)),
    queryFn: () => coursegroupsApi.fetchById(Number(courseGroupId)),
    enabled: !!courseGroupId,
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_GROUP_BY_ID(Number(courseGroupId)),
    });
  };

  return { invalidate, isLoading, isFetching, courseGroup: data?.data };
};
